// extracted by mini-css-extract-plugin
export default {"dft-messenger":"styles_dft-messenger__xzMER","message-list-wrapper":"styles_message-list-wrapper__bqLy1","dft-message-list":"styles_dft-message-list__v-yXy"};